// Values that the database CHECK constraints, the API and the UI all agree on.
// Changing one of these needs a matching migration.

export const GAME_ROLES = ['carry', 'support', 'midlane', 'offlane', 'jungle']

export const GAME_ROLE_LABELS = {
  carry: 'Carry',
  support: 'Support',
  midlane: 'Midlane',
  offlane: 'Offlane',
  jungle: 'Jungle',
}

// What a sub request can ask for: a role, or anyone ("fill").
export const SUB_ROLES = [...GAME_ROLES, 'fill']
export const SUB_ROLE_LABELS = { ...GAME_ROLE_LABELS, fill: 'Any role' }
// What a team needs the sub for.
export const SUB_PURPOSES = ['scrim', 'event', 'other']
export const SUB_PURPOSE_LABELS = { scrim: 'Scrim', event: 'Event', other: 'Other' }

export const PLATFORMS = ['pc', 'playstation', 'xbox']

export const PLATFORM_LABELS = {
  pc: 'PC',
  playstation: 'PS5',
  xbox: 'Xbox Series X|S',
  mixed: 'Crossplay',
}

export const TEAM_PLATFORMS = [...PLATFORMS, 'mixed']

export const STAGE_FORMATS = ['single_elim', 'double_elim', 'round_robin', 'swiss']

export const STAGE_FORMAT_LABELS = {
  single_elim: 'Single elimination',
  double_elim: 'Double elimination',
  round_robin: 'Round robin',
  swiss: 'Swiss',
}

// Standings tiebreakers an organizer can order for round-robin and Swiss
// stages. An organizer's own decision always comes last.
export const STANDINGS_TIEBREAKERS = ['match_wins', 'game_diff', 'head_to_head', 'game_wins', 'buchholz']

export const TIEBREAKER_LABELS = {
  match_wins: 'Match wins',
  game_diff: 'Game difference',
  head_to_head: 'Head-to-head',
  game_wins: 'Game wins',
  buchholz: 'Buchholz (opponents’ wins)',
  manual: 'Organizer decision',
}

export const DEFAULT_TIEBREAKERS = {
  round_robin: ['match_wins', 'game_diff', 'head_to_head', 'game_wins'],
  swiss: ['match_wins', 'buchholz', 'game_diff', 'head_to_head'],
}

export const EVENT_VISIBILITIES = ['draft', 'unlisted', 'public']

export const EVENT_STATUSES = ['upcoming', 'live', 'completed', 'cancelled']

export const MATCH_STATUSES = [
  'pending',
  'ready',
  'live',
  'awaiting_confirmation',
  'disputed',
  'completed',
  'bye',
  'cancelled',
]

export const BEST_OF = [1, 3, 5]

export const ORG_ROLES = ['owner', 'admin', 'staff', 'referee', 'caster']

export const REGISTRATION_STATUSES = [
  'pending',
  'approved',
  'waitlisted',
  'denied',
  'withdrawn',
  'disqualified',
]

export const SITE_NAME = 'Pred Hub'

export const NOT_AFFILIATED_NOTICE =
  'Pred Hub is a fan-made community project. It is not affiliated with or endorsed by Omeda Studios. ' +
  'Predecessor and related names are trademarks of their respective owners.'

export const GAME_MODES = {
  standard: 'Standard 5v5',
  '4v4': '4v4',
  '3v3': '3v3',
  '2v2': '2v2',
  '1v1': '1v1',
  brawl: 'Brawl',
  aram: 'ARAM',
  custom: 'Custom rules',
}

// Modes that fix how many players a team fields. Brawl, ARAM and custom
// rules leave it to the organizer.
export const GAME_MODE_TEAM_SIZE = { standard: 5, '4v4': 4, '3v3': 3, '2v2': 2, '1v1': 1 }

// The event page builder's fixed set of sections, in their default order.
export const SECTION_KINDS = {
  overview: 'Overview',
  format: 'Format',
  schedule: 'Schedule',
  rules: 'Rules',
  prize_pool: 'Prize pool',
  streams: 'Streams',
  sponsors: 'Sponsors',
  staff: 'Staff',
  faq: 'FAQ',
  contact: 'Contact',
  links: 'Links',
}

export const ORG_ROLE_LABELS = {
  owner: 'Owner',
  admin: 'Admin',
  staff: 'Staff',
  referee: 'Referee',
  caster: 'Caster',
}

export const ROSTER_LOCK_LABELS = {
  event_start: 'When the event starts',
  checkin_open: 'When check-in opens',
  registration_close: 'When registration closes',
}

export const CURRENCIES = ['USD', 'EUR', 'GBP', 'AUD', 'CAD', 'BRL', 'SGD', 'NZD', 'JPY', 'SEK']

// What a report can be about, and why.
export const REPORT_TARGETS = ['team', 'player', 'event', 'org', 'highlight', 'chat_message']

export const REPORT_TARGET_LABELS = { team: 'Team', player: 'Player', event: 'Event', org: 'Organization', highlight: 'Clip', chat_message: 'Chat message' }

// Support requests to the Pred Hub team.
export const SUPPORT_KINDS = ['help', 'appeal', 'bug', 'privacy', 'other']

export const SUPPORT_KIND_LABELS = {
  help: 'Help using Pred Hub',
  appeal: 'Appeal a ban or takedown',
  bug: 'Something’s broken',
  privacy: 'My data and privacy',
  other: 'Something else',
}

// open: waiting on the Pred Hub team; waiting: waiting on the player.
export const SUPPORT_STATUSES = ['open', 'waiting', 'closed']

export const REPORT_REASONS = ['cheating', 'harassment', 'offensive', 'impersonation', 'spam', 'other']

export const REPORT_REASON_LABELS = {
  cheating: 'Cheating or match fixing',
  harassment: 'Harassment or hate',
  offensive: 'Offensive name, image or text',
  impersonation: 'Impersonation',
  spam: 'Spam or scam',
  other: 'Something else',
}

// How long a ban lasts, in days; null is until lifted.
export const BAN_LENGTHS = [1, 7, 30, null]
